import { signal, type Signal } from '@preact/signals-react';
import { useSignals } from '@preact/signals-react/runtime';
import type { AppParams } from '../types';

/**
 * Single source of truth for the params passed to TutorWidget.mount().
 * Lives at module level so any feature can subscribe to it.
 */
export const paramsSignal: Signal<AppParams | null> = signal(null);

export function useAppParams(): AppParams | null {
  useSignals();
  return paramsSignal.value;
}
